module.exports = __webpack_public_path__ + "img/ibrake.53f6ded6.jpg";